import React, {Fragment,Component} from 'react';
import { withRouter } from 'react-router-dom';
import { withSnackbar } from 'notistack';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField, Box, FormControlLabel, Checkbox,Tooltip, CircularProgress, Table, TableHead, TableRow, TableCell, TableBody } from '@material-ui/core';
import { isMobile } from 'react-device-detect';
import Autocomplete from '@material-ui/lab/Autocomplete';
import MomentUtils from '@date-io/moment';
import { MuiPickersUtilsProvider, KeyboardDatePicker} from '@material-ui/pickers';
import moment from 'moment';
import EditIcon from '@material-ui/icons/Edit';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { addAttachmentApi, addEditAssemblyShopVisitApi, deleteAttachmentApi, getModuleDescriptionApi } from '../apiServices';
import { shopVisitObj, errorCode } from '../';
import { fieldDateFormat, backendDateFormat } from '../../../constants';
import { fieldValidation } from '../../../utils/formValidation';
import { capitalizeFirstLetter, checkApiStatus, checkLicenseStatus } from '../../../utils';
import { regexConstants} from '../../../constants/regEx';
import { trackActivity } from '../../../utils/mixpanel';
import {CustomDropzone,CustomChip, PreviewDocsModal, DeletePopUp, PageLoader} from '../../../shared_elements'
import { gaTelesisInstance, mtInstance, titanAviInstance } from '../../../shared_elements/components';
import { globalGetService } from '../../../utils/globalApiServices';
import { Info } from "@material-ui/icons";

class AddEditShopVisit extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modal:false,
      licenseModal:false,
      licenseModalMessage:'',
      shopVisit:{},
      error:{},
      mode:'',
      heading:'',
      previewDocs : "",
      deleteItem:"",
      deleteAttachmentModal:false,
      attachedDoc:[],
      moduleList:[],
      pageLoader :false,
      buttonLoader :false,
      majorAssemblyPrsv: [],
      majorAssemblyLlp: [],
    }
    this.addEditAssemblyShopVisitApi = addEditAssemblyShopVisitApi.bind(this);
    this.addAttachmentApi = addAttachmentApi.bind(this);
    this.deleteAttachmentApi = deleteAttachmentApi.bind(this);
    this.getModuleDescriptionApi = getModuleDescriptionApi.bind(this)
  }
 componentDidMount() {
  const { shopVisit, assemblyType } = this.props;
  const assetSlug = shopVisit?.asset_slug;

  if (shopVisit?.prsv) {
    this.getMajorAssemblyApi(assemblyType, assetSlug, "?prsv=true&llp_replacement=false");
  }

  if (shopVisit?.llp_replacement) {
    this.getMajorAssemblyApi(assemblyType, assetSlug, "?prsv=false&llp_replacement=true");
  }
}

  getMajorAssemblyApi = (assetType, assetSlug, query, target) => {
  globalGetService(`/maintenance/${assetType}/asset/${assetSlug}/reserve_rates/`, query) 
    .then(response => {
      if (checkApiStatus(response)) {
        const data = response?.data?.data || [];
        if (data.length === 0 && (query?.prsv===true||query?.llp_replacement===true)) {
          this.props.enqueueSnackbar(`Kindly add ${target === 'majorAssemblyPrsv' ? 'PRSV' : 'LLP Replacement'} Reserve Rates for this Asset.`, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' },
          });
        }
        this.setState({ [target]: data });
      }
    });
};

 
  updateErrorField = (key, message) => {
    this.setState(prevState =>({
      ...prevState,
      error:{
        ...prevState.error,
        [key]:message
      }
    }))
  }
   onFieldChange = (event, keyParam, data, gropedData) => {
    const {shopvisitData} = this.props
    // const assetSlug = this.props.shopvisitData?.asset_slug || this.props.match?.params?.assetSlug;
    const assetType = this.props.assemblyType;
    const moduleObj={
      fan_event:shopvisitData?.id &&shopvisitData?.fan_event ?shopvisitData?.fan_event :  false,
      hpc_event:shopvisitData?.id &&shopvisitData?.hpc_event ?shopvisitData?.hpc_event:  false,
      hpt_event:shopvisitData?.id &&shopvisitData?.hpt_event ?shopvisitData?.hpt_event:  false,
      lpt_event :shopvisitData?.id &&shopvisitData?.lpt_event ?shopvisitData?.lpt_event:  false,
    }
    if(keyParam === "event" ){
      this.setState(prevState => ({
        ...prevState,
        shopVisit: {
          ...prevState.shopVisit,
          llp_replacement: shopvisitData?.id &&shopvisitData?.llp_replacement ?shopvisitData?.llp_replacement:  false,
          prsv:shopvisitData?.id &&shopvisitData?.prsv ?shopvisitData?.prsv:  false,
          ...moduleObj,
          [keyParam]: data
        }
      }))
    }else if(keyParam ==='llp_replacement'||keyParam ==='prsv'){
          const assetSlug = this.state?.shopVisit?.event?.slug||shopvisitData?.asset_slug;
          if (keyParam ==='prsv') {
          let query ={'shop_visit_date':this.state.shopVisit?.shop_visit_date,'prsv':data}
          this.getMajorAssemblyApi(assetType, assetSlug, query, 'majorAssemblyPrsv');
          this.setState(prevState => ({ ...prevState, shopVisit: { ...prevState.shopVisit, [keyParam]: data } }))
        }

        if (keyParam ==='llp_replacement') {
          let query ={'shop_visit_date':this.state.shopVisit?.shop_visit_date,'llp_replacement':data}
          this.getMajorAssemblyApi(assetType, assetSlug, query, 'majorAssemblyLlp');
          this.setState(prevState => ({ ...prevState, shopVisit: { ...prevState.shopVisit, [keyParam]: data } }))
        }
    }
    else if (gropedData ==='grouped_lg_data'){
      this.setState(prevState=>({
        ...prevState,
        shopVisit:{
          ...prevState.shopVisit,
          'grouped_lg_data':{
            ...prevState.shopVisit?.grouped_lg_data,
            [data]: {...prevState?.shopVisit?.grouped_lg_data?.[data],
              [keyParam]:event
            },
          }
        }
      }))
    }
    else{
      this.setState(prevState => ({
        ...prevState,
        shopVisit: {
          ...prevState.shopVisit,
          [keyParam]: data
        }
      }))
    }
   }

  onCheckboxChange = (keyParam, value) => {
    const oldModuleArray = ["fan_event", "hpc_event", "hpt_event", 'lpt_event',]
    if (oldModuleArray?.includes(keyParam)) {
      this.setState(prevState => ({
        ...prevState,
        shopVisit: {
          ...prevState.shopVisit,
          [keyParam]: value
        }
      }))
    } else {
      this.setState(prevState => ({
        ...prevState,
        shopVisit: {
          ...prevState.shopVisit,
          other_events: {
            ...prevState.shopVisit.other_events,
            [keyParam]: value
          }
        }
      }))
    }
  }

  
  addEditShopVisit = () => {
    const { shopVisit } = this.state
    const { assemblyType,id} = this.props;
    let validationInputs = {
      event:errorCode['event'][fieldValidation({...errorCode['eventObj'], fieldval: shopVisit.event})],
      shop_visit_start_date:moment(shopVisit?.shop_visit_start_date, 'YYYY.MM.DD').endOf('day').diff(moment(shopVisit.shop_visit_date).endOf('day'), 'days') > 0 ? `Please Enter Date less than ${assemblyType == "airframe" ? "Event": 'Shop Visit'} Completion Date`: moment(shopVisit.shop_visit_start_date, 'YYYY.MM.DD').endOf('day').diff(moment(shopVisit?.event?.date_of_manufacture).endOf('day'), 'days') < 0 ? " Please Select Date greater than Date of Manufacturing " : errorCode['shop_visit_start_date'][fieldValidation({...errorCode['shop_visit_start_dateObj'], fieldval:shopVisit.shop_visit_start_date})],
      shop_visit_date:errorCode['shop_visit_date'][fieldValidation({...errorCode['shop_visit_dateObj'], fieldval:shopVisit.shop_visit_date})],
      cost:errorCode['cost'][fieldValidation({...errorCode['costObj'], fieldval:shopVisit?.cost})],
      tsn:assemblyType === "lg" || shopVisit?.is_grouped && !this.props?.shopvisitData?.id? '' :  shopVisit?.event_id === 71  || shopVisit?.event?.event_id === 71 ? '' : errorCode['tsn'][fieldValidation({...errorCode['tsnObj'], fieldval:shopVisit?.tsn})],
      csn:assemblyType === "apu" || shopVisit?.is_grouped && !this.props?.shopvisitData?.id? '' : shopVisit?.event_id === 70 || shopVisit?.event?.event_id === 70 ? ''  : errorCode['csn'][fieldValidation({...errorCode['csnObj'], fieldval:shopVisit?.csn})],
      prsv_reserve_account_id: shopVisit.prsv && assemblyType === "engine" ? shopVisit.prsv_reserve_account_id ? '' : 'Please select PRSV Reserve Account' : '',
      llp_reserve_account_id: shopVisit.llp_replacement && assemblyType === "engine" ? shopVisit.llp_reserve_account_id ? '' : 'Please select LLP Replacement Reserve Account' : ''
    }
    if (shopVisit.llp_replacement || shopVisit.prsv) {
      if (shopVisit.llp_replacement && !this.state.majorAssemblyLlp.length) {
        this.props.enqueueSnackbar('Please add Reserve Rates with claim type LLP Relpacement', { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
        return;
      }
      if (shopVisit.prsv && !this.state.majorAssemblyPrsv.length) {
        this.props.enqueueSnackbar('Please add Reserve Rates with claim type PRSV', { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
        return;
      }
    }
    if (!shopVisit.llp_replacement && !shopVisit.prsv && this.props.assemblyType==="engine") {
        this.props.enqueueSnackbar('Please select either PRSV Event or LLP Replacement.', { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
        return;
    }
    let bulkFlag = true
    if(shopVisit?.is_grouped && !this.props?.shopvisitData?.id){
      let lgMAList = this.props.maList?.list.filter(item=> item?.is_grouped)
      let updatedSV = shopVisit?.grouped_lg_data ? shopVisit : {...shopVisit, grouped_lg_data:{}} 
      let lgValidation = lgMAList?.map(item => ({
        tsn: updatedSV?.grouped_lg_data[item?.id.toString()]?.tsn ?'':'Please Enter TSN at Shop Visit',
        csn: updatedSV?.grouped_lg_data[item?.id.toString()]?.csn ?'':'Please Enter CSN at Shop Visit',
        id:item.id
      }))
      let  objValidation = lgValidation.reduce((acc, item) => {
        acc[item.id] = { ...item, id: '' };
        return acc;
      }, {})
      this.setState({groupError:objValidation})
      bulkFlag = Object.keys(objValidation).every(k=> Object.keys(objValidation[k]).every(ch => {return objValidation[k][ch] === ''}))
    }
    if(Object.keys(validationInputs).every((k)=>{return validationInputs[k] ==='' }) && bulkFlag){
      if (this.state.attachedDoc?.length>10) {
        this.props.enqueueSnackbar('Only 10 attachment can be attached in one time.', { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
        return; 
      }
      if (this.state.attachedDoc?.length+ shopVisit?.attachments?.length>50) {
        this.props.enqueueSnackbar('Only 50 attachment can be attached.', { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
        return; 
      }
      let payload
      if(shopVisit?.prsv == false){
        payload ={...shopVisit,fan_event:false,hpc_event:false,hpt_event:false,lpt_event:false,attachments :[],prsv_reserve_account_id:shopVisit.prsv?shopVisit.prsv_reserve_account_id:null}
       
      }else payload = {...shopVisit,attachments :[],llp_reserve_account_id:shopVisit.llp_replacement?shopVisit.llp_reserve_account_id:null }
      this.setState({buttonLoader :true})
      this.addEditAssemblyShopVisitApi(this.props, payload, assemblyType)
      .then(response => {
        if(checkApiStatus(response)){
          this.setState({buttonLoader :false})
          if (this.state?.attachedDoc?.length > 0) {
            this.addAttachmentApi(id ? "Shop Visit updated successfully" : "Shop Visit created successfully",response?.data?.data?.id, this.props, this.state.attachedDoc, "shopvisit", this.toggleFnc);
          } else {
            this?.props?.enqueueSnackbar("Shop Visit updated successfully", { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
            this?.props?.getResponseBack();
          }
          this.setState({modal:false, mode:'', shopVisit:{}, error:{}});
          trackActivity('Item Added / Edited', {
              page_type: this.props.pageType,
              page_title: 'Shop visit',
              asset_slug: this.props.match.params.assetSlug,
              asset_type: this.props.match.params.assetType,
              assembly_type: this.props.assemblyType,
            })
        }else if(checkLicenseStatus(response)){
          this.setState({buttonLoader :false})
          this.setState({modal:false, mode:'', shopVisit:{}, error:{},});
          this.props.toggleLicenseFn(true, response.data.message)
        }else{
          this.setState({buttonLoader :false})
          this.props.enqueueSnackbar(<div> <div dangerouslySetInnerHTML={{ __html: response?.data?.message}}></div> </div>, {variant: 'error', anchorOrigin:{vertical: 'top',horizontal: 'right'}});
        }
      })
    }else {
      this.setState({error: validationInputs})
    }
  }
  toggleFnc = (key, status) => {
    this.setState({ [key]: status })
  }
  onAttachmentDelete = () => {
    this.setState(prevState => ({
      ...prevState,
      shopVisit: {
        ...prevState.shopVisit,
        attachments: this.state.shopVisit?.attachments?.filter(item => item.uuid !== this.state.deleteItem.uuid)
      }
    }))
    this.deleteAttachmentApi(this.state.deleteItem, "shopvisit", this.props.id, this.toggleFnc)
  }
  setGroupError =(type, key)=>{
    this.setState(prevState=>({
      ...prevState,
      groupError:{
        ...prevState.groupError,
        [key]:{
          ...prevState.groupError?.[key],
          [type]:''
        }
      }
    }))
  }
  render(){
    const { modal,shopVisit, error,moduleList,majorAssemblyLlp,majorAssemblyPrsv, groupError } = this.state
    const { id, buttonText, assemblyType, mntEvents, shopvisitData, mode, eventName, eventId, maList} = this.props;
    return (
      <Fragment>
        {mode === "view" ?
        <Tooltip title='View'>
        <VisibilityIcon color='primary' style={{ cursor: 'pointer' }}
          onClick={() => {
            this.setState({ modal: true, mode: 'view', shopVisit: { ...shopvisitData, event: { event_id: eventId, event_name: eventName, date_of_manufacture: shopvisitData?.date_of_manufacture } }, error: {}, });
            if (shopvisitData?.asset_slug) {
              this.getModuleDescriptionApi(shopvisitData?.asset_slug, "module");
            }
            if (shopvisitData?.prsv) {
              this.getMajorAssemblyApi(assemblyType, shopvisitData?.asset_slug, { shop_visit_date: shopvisitData?.shop_visit_date, prsv: true }, 'majorAssemblyPrsv');
            }

            if (shopvisitData?.llp_replacement) {
              this.getMajorAssemblyApi(assemblyType, shopvisitData?.asset_slug, { shop_visit_date: shopvisitData?.shop_visit_date, llp_replacement: true }, 'majorAssemblyLlp');
            }
          }} />
      </Tooltip> :
        id && mode === "edit" ?<Tooltip title="Edit" arrow><EditIcon
          onClick={() => {
            this.setState({ modal: true, mode: 'edit', shopVisit: { ...shopvisitData, event: { event_id: eventId, event_name: eventName, date_of_manufacture: shopvisitData?.date_of_manufacture } }, error: {}, });
            if(shopvisitData?.asset_slug){
              this.getModuleDescriptionApi( shopvisitData?.asset_slug  , "module");
              }
              if (shopvisitData?.prsv) {
                this.getMajorAssemblyApi(assemblyType, shopvisitData?.asset_slug, { shop_visit_date: shopvisitData?.shop_visit_date, prsv: true }, 'majorAssemblyPrsv');
              }

              if (shopvisitData?.llp_replacement) {
                this.getMajorAssemblyApi(assemblyType, shopvisitData?.asset_slug, { shop_visit_date: shopvisitData?.shop_visit_date, llp_replacement: true }, 'majorAssemblyLlp');
              }
          }}
        color="primary" /></Tooltip> :
           <Button className="add-sv-cta" color="primary" size='small' variant="contained" onClick={() => this.setState({modal:true, shopVisit:shopVisitObj, error:{}}, () => trackActivity('Item Clicked', { item_type: `${mode} ${buttonText}`, assembly_type: this.props.assemblyType }))}>+ {mode} {buttonText}</Button>
         }
       
        { modal ?
          <Dialog
            open={modal}
            onClose={() => this.setState({modal:false, mode:'add', shopVisit:shopVisitObj, error:{}})}
            aria-labelledby="scroll-dialog-title"
          >
            <DialogTitle id="scroll-dialog-title">
              {capitalizeFirstLetter(mode)} {buttonText}
            </DialogTitle>
            <DialogContent dividers={true}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  {shopVisit.id ? shopVisit.name:
                    <Autocomplete
                      options={mntEvents}
                      getOptionLabel={option => `${option?.event_name ?? '--'} ${option?.remarks ? `(${option?.remarks})` : ''}` }
                      id="event"
                      value={shopVisit.event || null}
                      renderOption={(props, option) => <li {...props}>{props.event_name}{props?.remarks ?`(${props?.remarks ?? ''})` :null}{props.is_grouped && <span style={{ marginLeft: 6 }} className="grouped-lg">Grouped LG</span>}</li>}
                      onChange={(e, value) => this.onFieldChange(e, 'event', value)}
                      renderInput={params => <TextField {...params} disabled={mode === "view"} required label={assemblyType === 'airframe' ? 'Select Maintenance Event' : 'Select Shop Visit for'} margin="normal" fullWidth InputLabelProps={{ shrink: true }} error={!!error.event} helperText={error.event ? (assemblyType === 'Maintenance Event' ? 'Please select Maintenance Event' : error.event) : ''} onFocus={() => this.updateErrorField('event', '')} 
                      InputProps={{ ...params.InputProps, endAdornment: <>{shopVisit.event && shopVisit.event.is_grouped && <span className="grouped-lg" style={{ marginRight: 8 }}>Grouped LG</span>}{params.InputProps.endAdornment}</> }} />}
                    />
                  }
                </Grid>
                <Grid item xs={6}>
                  <MuiPickersUtilsProvider utils={MomentUtils}>
                    <KeyboardDatePicker
                       margin="normal"
                       id="shop_visit_start_date"
                       label={assemblyType === "airframe" ? 'Event Start Date' : 'Shop Visit Start Date'}
                       format={fieldDateFormat}
                       fullWidth
                       InputLabelProps={{shrink: true}}
                       value={shopVisit.shop_visit_start_date ? moment(shopVisit.shop_visit_start_date).format('MMM DD, YYYY'):null}
                       onChange={(data, value) => this.onFieldChange(value, 'shop_visit_start_date', data ? moment(data).format(backendDateFormat):data)}
                       onFocus={()=>this.updateErrorField('shop_visit_start_date', '')}
                       maxDate={moment()}
                       minDate={shopVisit?.event?.date_of_manufacture ? moment(shopVisit?.event?.date_of_manufacture).format() : '01-01-1900'}
                       error={ error.shop_visit_start_date ? true:false }
                       helperText={error.shop_visit_start_date ? error.shop_visit_start_date : ''}
                       disabled={mode === "view"}
                     />
                  </MuiPickersUtilsProvider>
                </Grid>
                <Grid item xs={6}>
                  <MuiPickersUtilsProvider utils={MomentUtils}>
                    <KeyboardDatePicker
                       required
                       margin="normal"
                       id="start_date"
                       label={assemblyType === "airframe" ? 'Event Completion Date' : 'Shop Visit Completion Date'}
                       format={fieldDateFormat}
                       fullWidth
                       minDate={shopVisit?.shop_visit_start_date ? shopVisit?.shop_visit_start_date : shopVisit?.event?.date_of_manufacture ? shopVisit?.event?.date_of_manufacture : '01-01-1900'}
                       InputLabelProps={{shrink: true}}
                       value={shopVisit.shop_visit_date ? moment(shopVisit.shop_visit_date).format('MMM DD, YYYY'):null}
                       onChange={(data, value) => this.onFieldChange(value, 'shop_visit_date', data ? moment(data).format(backendDateFormat):data)}
                       onFocus={()=>this.updateErrorField('shop_visit_date', '')}
                       maxDate={moment()}
                       error={ error.shop_visit_date ? true:false }
                       helperText={error.shop_visit_date ? assemblyType === 'airframe' ? 'Please enter Event Completion Date': error.shop_visit_date : ''}
                       disabled={mode === "view"}
                     />
                  </MuiPickersUtilsProvider>
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    id="cost"
                    label={
                      <Box style={isMobile ? { position:'relative', top:'-18px'} : {}}>
                        { assemblyType === 'airframe' ? <p>Event Cost (USD)<sup>*</sup></p> : <p>Shop Visit Cost (USD)<sup>*</sup></p>}
                      </Box>
                    }
                    fullWidth
                    margin="normal"
                    value={shopVisit.cost}
                    onChange={(e, value) => {regexConstants.decimalnodotstart.test(e.target.value)  ?  this.onFieldChange(e,'cost', e.target.value): e.preventDefault()}}
                    error={error.cost ? true:false }
                    onFocus={()=>this.updateErrorField('cost', '')}
                    InputLabelProps={{shrink: true}}
                    helperText={error.cost ? assemblyType === 'airframe' ?'Please enter Event Cost': error.cost :''}
                    disabled={mode === "view"}
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Checkbox  disabled={(assemblyType== "engine" && !shopVisit?.event?.event_id) || !shopVisit.shop_visit_date || mode === "view"}   color="primary" checked={shopVisit.prsv } onChange={(e) => {
                        this.onFieldChange(e, 'prsv', e.target.checked);
                        if(shopVisit?.event?.slug || !shopVisit.shop_visit_date ||  shopvisitData?.asset_slug ){
                          this.getModuleDescriptionApi( shopvisitData?.asset_slug?  shopvisitData?.asset_slug : shopVisit?.event?.slug  , "module")
                        }
                      }}
                        value="prsv" />
                    }
                    label="PRSV Event"
                  />
                   {assemblyType === "engine" ?   <FormControlLabel
                    control={
                      <Checkbox disabled={!shopVisit?.event?.event_id || !shopVisit.shop_visit_date || !shopVisit.shop_visit_date  || mode === "view"} color="primary" checked={shopVisit.llp_replacement} onChange={(e) => {
                        this.onFieldChange(e, 'llp_replacement', e.target.checked);
                      }} value="llp_replacement" />
                    }
                    label="LLP Replacement"
                  /> : null}
                  {assemblyType === "lg" && mtInstance ?  <> <FormControlLabel
                    control={
                      <Checkbox disabled={maList?.is_grouped == false? true: !shopVisit?.event?.event_id || !shopVisit.shop_visit_date || !shopVisit.shop_visit_date  || mode === "view"} color="primary" checked={shopVisit.is_grouped} onChange={(e) => {
                        this.onFieldChange(e, 'is_grouped', e.target.checked);
                      }} value="is_grouped" />
                    }
                    label="Is Grouped SV"
                  /> {maList?.is_grouped == false ?
                    <Tooltip title='Grouped SV is disabled as LG is not Grouped'>
                      <Info style={{ fontSize: '15px', marginLeft: '-13px' }} />
                    </Tooltip> : null}
                  </> : null}
                 
                </Grid>
                {assemblyType === "engine" && (shopVisit?.prsv)?
                <Grid item md={6}>
                    <Autocomplete
                      options={majorAssemblyPrsv}
                      getOptionLabel={option => option.name}
                      id="prsv_reserve_account_id"
                      disabled={mode === "view"}
                      value={ majorAssemblyPrsv.find(option => option.id === (shopVisit.prsv_reserve_account_id) ) || null }
                      onChange={(e, value) => {this.onFieldChange(e, 'prsv_reserve_account_id', value ? value.id : null);this.updateErrorField('prsv_reserve_account_id', '')}}
                      onFocus={()=>this.updateErrorField('prsv_reserve_account_id', '')}
                      renderInput={params => <TextField required disabled={mode === "view"} fullWidth {...params} error={error.prsv_reserve_account_id ?true:false } helperText={ error.prsv_reserve_account_id } margin="normal" label={'PSRV Reserve Account'} InputLabelProps={{shrink: true}} />}
                    /> 
                </Grid>: null}
                {assemblyType === "engine" && (shopVisit?.llp_replacement) ?
                <Grid item md={6}>
                    <Autocomplete
                      options={majorAssemblyLlp}
                      getOptionLabel={option => option.name}
                      id="llp_reserve_account_id"
                      disabled={mode === "view"}
                      value={ majorAssemblyLlp.find(option => option.id === (shopVisit.llp_reserve_account_id) ) || null }
                      onChange={(e, value) => this.onFieldChange(e, 'llp_reserve_account_id', value ? value.id : null)}
                      onFocus={()=>this.updateErrorField('llp_reserve_account_id', '')}
                      renderInput={params => <TextField required disabled={mode === "view"} fullWidth {...params} error={error.llp_reserve_account_id ?true:false } helperText={ error.llp_reserve_account_id } label={'LLP Replacement Reserve Account'} margin="normal" InputLabelProps={{ shrink: true }} />}
                    /> 
                </Grid>: null}
                {assemblyType === "engine" && shopVisit?.prsv && moduleList?.length > 0 ? <Grid item xs={12}>
                  {moduleList?.map((module, index) => {
                    return (<FormControlLabel
                      key={index + module}
                      control={
                        <Checkbox 
                        disabled={mode === "view"}
                        color="primary" 
                        checked={ shopVisit?.prsv && ((shopVisit?.other_events && shopVisit?.other_events[module.value])|| (shopVisit &&shopVisit[module.value]))} 
                        onChange={(e) => this.onCheckboxChange( module.value, e.target.checked)} 
                        value={module.value} />
                        
                      }
                      label={module.label}
                    />)
                  })}
                </Grid> : null }
              {titanAviInstance?null:
                <Grid item xs={12}>
                  <TextField
                   disabled={mode === "view"}
                    id="removal_reason"
                    label={assemblyType === "airframe" ? 'Reason for Event': 'Reason for Shop Visit'}
                    fullWidth
                    multiline
                    rows="4"
                    margin="normal"
                    value={shopVisit.removal_reason}
                    onChange={(e, value) => this.onFieldChange(e, 'removal_reason', e.target.value)}
                    InputLabelProps={{shrink: true}}
                  />
                </Grid>}
                <Grid item xs={12}>
                  <TextField
                   disabled={mode === "view"}
                    id="workscope_details"
                    label={assemblyType === 'airframe' ? "Event Workscope / Details":"Shop Visit Workscope / Details"}
                    fullWidth
                    margin="normal"
                    multiline
                    rows="4"
                    value={shopVisit.workscope_details}
                    onChange={(e, value) => this.onFieldChange(e, 'workscope_details', e.target.value)}
                    InputLabelProps={{shrink: true}}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                   disabled={mode === "view"}
                    id="shop_visit_facility"
                    label={assemblyType === 'airframe' ? "Event Facility" : "Shop Visit Facility"}
                    fullWidth
                    margin="normal"
                    value={shopVisit.shop_visit_facility}
                    onChange={(e, value) => this.onFieldChange(e, 'shop_visit_facility', e.target.value)}
                    InputLabelProps={{shrink: true}}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                   disabled={mode === "view"}
                    id="facility_location"
                    label="Facility Location"
                    fullWidth
                    margin="normal"
                    value={shopVisit.facility_location}
                    onChange={(e, value) => this.onFieldChange(e, 'facility_location', e.target.value)}
                    InputLabelProps={{shrink: true}}
                  />
                </Grid>
               {shopVisit?.is_grouped && !shopvisitData?.id? 
               <Table className='mui-table-format'>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>LG Serial Number</TableCell>
                                            <TableCell>TSN at Shop Visit *</TableCell>
                                            <TableCell>CSN at Shop Visit *</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {maList?.list?.filter(item => item?.is_grouped).map(item =>
                                        (<TableRow>
                                            <TableCell>
                                              <b> {item?.major_assembly_name || item?.serial_number || '--'}</b>
                                            </TableCell>
                                            <TableCell>
                                                {<TextField
                                                    name='tsn_last'
                                                    value={shopVisit?.grouped_lg_data && shopVisit?.grouped_lg_data?.[item?.id] && shopVisit?.grouped_lg_data?.[item?.id]?.tsn ? shopVisit?.grouped_lg_data?.[item?.id]?.tsn :''}
                                                    fullWidth
                                                    margin="normal"
                                                    inputProps={{ maxLength: 25 }}
                                                    onChange={(e) => {this.onFieldChange( e.target.value, 'tsn',item?.id.toString() , 'grouped_lg_data' )}}
                                                    InputLabelProps={{ shrink: true }}
                                                    variant='outlined'
                                                    error={groupError?.[item?.id]?.tsn ? true : false}
                                                    onFocus={() => this.setGroupError('tsn',item?.id)}
                                                    helperText={groupError?.[item?.id]?.tsn || ''}
                                                />}
                                            </TableCell>
                                            <TableCell>
                                                {<TextField
                                                    name='csn_last'
                                                    value={shopVisit?.grouped_lg_data && shopVisit?.grouped_lg_data?.[item?.id] && shopVisit?.grouped_lg_data?.[item?.id]?.csn ? shopVisit?.grouped_lg_data?.[item?.id]?.csn :''}
                                                    fullWidth
                                                    margin="normal"
                                                    inputProps={{ maxLength: 25 }}
                                                    onChange={(e) =>{regexConstants.numberWithDot.test(e.target.value) ? this.onFieldChange(e.target.value, 'csn', item?.id.toString(), 'grouped_lg_data' ) :e.preventDefault()}}
                                                    InputLabelProps={{ shrink: true }}
                                                    variant='outlined'
                                                    error={groupError?.[item?.id]?.csn ? true : false}
                                                    onFocus={() => this.setGroupError('csn',item?.id)}
                                                    helperText={groupError?.[item?.id]?.csn || ''}
                                                />}
                                            </TableCell>
                                        </TableRow>))
                                        }
                                    </TableBody>
                                </Table>:
                <>
                <Grid item xs={6}>
                  <TextField
                    required={true}
                    id="tsn"
                    label={assemblyType === "airframe" ? 'TSN at Event': 'TSN at Shop Visit'}
                    fullWidth
                    margin="normal"
                    value={shopVisit.tsn}
                    onFocus={()=> this.updateErrorField('tsn', '')}
                    onChange={(e, value) => {regexConstants.decimalnodotstart.test(e.target.value) ? this.onFieldChange(e, 'tsn', e.target.value):e.preventDefault()}}
                    error={error.tsn ? true:false }
                    InputLabelProps={{shrink: true}}
                    helperText={error.tsn ? assemblyType === 'airframe' ? 'Please enter TSN at Event': error.tsn :''}
                    disabled={shopVisit?.event_id === 71 || shopVisit?.event?.event_id === 71 || mode === "view"}
                  />
                </Grid>
                <Grid item xs={6} >
                  <TextField
                    required={assemblyType === "apu" ? false : true}
                    id="csn"
                    label={assemblyType === 'airframe' ?"CSN at Event":"CSN at Shop Visit"}
                    fullWidth
                    margin="normal"
                    value={shopVisit.csn}
                    onFocus={()=>this.updateErrorField('csn', '')}
                    onChange={(e, value) => {regexConstants.onlyNumeric.test(e.target.value)? this.onFieldChange(e, 'csn', e.target.value):e.preventDefault()}}
                    error={error.csn ? true:false }
                    InputLabelProps={{shrink: true}}
                    helperText={error.csn ? assemblyType === 'airframe' ? 'Please enter CSN at Event': error.csn : '' }
                    disabled={shopVisit?.event_id === 70 || shopVisit?.event?.event_id === 70 || mode === "view"}
                  />
                </Grid>
                </>}
                {gaTelesisInstance?
                <Grid item xs={12}>
                  <TextField
                   disabled={mode === "view"}
                    id="remarks"
                    label='Remarks'
                    fullWidth
                    margin="normal"
                    multiline
                    rows="4"
                    value={shopVisit?.remarks}
                    onChange={(e, value) => this.onFieldChange(e, 'remarks', e.target.value)}
                    InputLabelProps={{shrink: true}}
                  />
                </Grid>:null}
                {mode === 'view' ?
                    <div style={{ marginLeft: '8px', marginBottom: '20px' }}>
                      <p style={{ fontSize: '14px', color: 'rgb(160, 160, 160)', fontFamily: "Conv_IBMPlexSans-Regular" }}>Attachment(s) [Count: {shopVisit?.attachments?.length}]</p>
                      {shopVisit?.attachments?.length ? shopVisit?.attachments && shopVisit?.attachments.map((file, index) => (
                        <CustomChip
                          style={{ marginRight: '4px', marginTop: '7px'}}
                          title={file.name}
                          index={index}
                          label={file.name.substring(0, 14) + '...'}
                          onClick={(e) => { e.preventDefault(); e.stopPropagation();  this.setState({ previewDocs: file }) }}
                        />
                      )) : '--'}
                    </div>
                    :
                    (
                      <Grid item xs={12} style={{ marginBottom: '5px' }} className='drag-drop'>
                        <CustomDropzone
                          onChange={(files) => this.setState({ attachedDoc: files })}
                          componentData={shopVisit}
                          attachedDoc = {this.state.attachedDoc}
                          filesLimit={50}
                        >
                        </CustomDropzone>
                        {shopVisit?.attachments && shopVisit?.attachments.map((file, index) => (
                          <CustomChip
                            style={{ marginRight: '4px', marginTop: '7px'}}
                            title={file.name}
                            index={index}
                            label={file.name.substring(0, 14) + '...'}
                            onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.setState({ previewDocs: file })}}
                            onDelete={(e) => { e.preventDefault(); e.stopPropagation(); this.setState({ deleteAttachmentModal: true, deleteItem: file }); }}
                          />
                        ))}
                      </Grid>)}
              </Grid>
              
            </DialogContent>
            <DialogActions>
              <Button onClick={() => this.setState({modal:false, mode:'add', shopVisit:shopVisitObj, error:{}}, () => trackActivity('Item Clicked', { page_title: 'Shop Visit', page_type: this.props.pageType, activity_type: 'Cancel', assembly_type: this.props.assemblyType }))} className='mr-5' variant='outlined' size='small'  color="primary">Cancel</Button>
              {mode==="view" ? null :<Button size='small' variant="contained" onClick={this.addEditShopVisit} color="primary">{this.state.buttonLoader ? <CircularProgress color="#ffffff" size={24} /> : "Save"} </Button>}
            </DialogActions>
          </Dialog>:null
        }
        {this.state.previewDocs ? <PreviewDocsModal previewDocs={this.state.previewDocs} toggleModalFn={() => this.setState({ previewDocs: '' })} /> : null}
        {this.state.deleteAttachmentModal ?
          <DeletePopUp
          loader={this.state.buttonLoader}
            modal={this.state.deleteAttachmentModal}
            toggleModalFn={() => this.setState({ deleteAttachmentModal: false })}
            title="Delete Attachment"
            content={<h4>Are you sure you want to delete?</h4>}
            deleteRecordFn={() => this.onAttachmentDelete()}
          /> : null
        }
        {this.state.pageLoader ? <PageLoader /> :null}
      </Fragment>
    )
  }
}
export default withSnackbar(withRouter(AddEditShopVisit));
